/**
 * Coda - SPECIFICHE 9.1
 *
 * Sistema di tracciamento code di presentazione deleghe.
 */
import { z } from 'zod';
import { CassaCodeSchema, str } from './common.ts';

export const CodaSchema = z.object({
  id: z.number(),
  cassa: CassaCodeSchema,
  dataPresentazione: z.string(), // YYYY-MM-DD
  createdAt: str,
});

export type Coda = z.infer<typeof CodaSchema>;

export type CodaInsert = Omit<Coda, 'id' | 'createdAt'>;

// CodaConCount: definita in types/api-responses.ts come schema Zod

// Associazione coda <-> delega
export const CodaDelegaSchema = z.object({
  codaId: z.number(),
  delegaId: z.number(),
});

export type CodaDelega = z.infer<typeof CodaDelegaSchema>;
